export const GET_TAGS = 'GET_TAGS';
export const SET_TAGS = 'SET_TAGS';
